// 🔧 content_service.js
// ✅ Purpose: Canonical business service for Content Engine authoring
// ✅ Features:
// - Central entry point for Content Studio operations
// - Owns content authoring workflow
// - Coordinates providers and bundle services
// - Contains business rules only
// - No React logic
// - No Firestore implementation

import {
  queryContentItems,
} from "../providers/firestore_read_provider";

import {
  saveContentItem,
} from "../providers/firestore_write_provider";

import {
  buildAndPublishBundle,
} from "./bundle_service";

/**
 * Retrieves editable content items.
 *
 * This is the primary query used by the
 * future Content Studio.
 */
export async function getContentItems(filters = {}) {
  console.log(
    "[Communication Engine] Loading content items.",
    filters
  );

  try {
    return await queryContentItems(filters);
  } catch (error) {
    console.error(
      "[Communication Engine] Failed to load content items.",
      error
    );

    throw error;
  }
}

/**
 * Saves one editable Content Item.
 *
 * Phase 1:
 * Saves only.
 *
 * Future:
 * Validation
 * Versioning
 * Audit
 * AI assistance
 */
export async function saveDraft(contentItem) {
  console.log(
    "[Communication Engine] Saving draft:",
    contentItem?.key
  );

  try {
    await saveContentItem(contentItem);

    return contentItem;
  } catch (error) {
    console.error(
      "[Communication Engine] Failed to save draft.",
      error
    );

    throw error;
  }
}

/**
 * Publishes content for one area.
 *
 * Phase 1:
 * Simply rebuilds the runtime bundle.
 *
 * Future:
 * Manifest update
 * Cache invalidation
 * Publish history
 * Notifications
 */
export async function publishArea({
  area,
  scopeId,
  locale,
  profile,
  publishedBy,
}) {
  console.log(
    "[Communication Engine] Publishing area:",
    area
  );

  try {
    return await buildAndPublishBundle({
      area,
      scopeId,
      locale,
      profile,
      generatedBy: publishedBy,
    });
  } catch (error) {
    console.error(
      "[Communication Engine] Failed to publish area.",
      error
    );

    throw error;
  }
}